import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
  NavbarToggler,
  UncontrolledDropdown,
} from 'reactstrap';

import { UPSTREAM_EMAIL_ADDRESS } from 'upstream-shared/constants';
import { UpstreamToken } from 'upstream-shared/models';

import { paths } from '../paths';
import MainMenu from './MainMenu';
import { BOE, MCFE, useAppDispatch, useProductionUnits } from '../hooks';
import ConfirmDialog from './ConfirmDialog';
import { deleteMe } from '../actions/authActions';

interface HeaderProps {
  authUser?: UpstreamToken;
}

const DropdownItemLink = (props: { title?: string; to: string; children?: React.ReactNode }) => {
  return <DropdownItem tag={Link} {...props} />;
};

const Header = (props: HeaderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { authUser } = props;
  const { units, setProductionUnits } = useProductionUnits();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const dispatch = useAppDispatch();

  const setProductionUnitsMCFE = () => {
    setProductionUnits(MCFE);
  };

  const setProductionUnitsBOE = () => {
    setProductionUnits(BOE);
  };

  const isLoggedIn = !!authUser;

  const onDeleteConfirm = async () => {
    try {
      setDeleting(true);
      await dispatch(deleteMe());
    } finally {
      setDeleting(false);
      setConfirmOpen(false);
      setIsOpen(false);
    }
  };

  return (
    <div className={'contentPageHeader'}>
      <Navbar color={'white'} light={true} dark={false} expand={'md'} className={'navbar'}>
        <Container id={'header-container'} fluid>
          <Link to="/" className={'logo'}>
            <picture>
              <source media="(min-width:650px)" srcSet="/CARA_logo-desk.png" />
              <source media="(min-width:465px)" srcSet="/CARA_logo-desk.png" />
              <img src="/CARA_logo-desk.png" alt="CARA logo" />
            </picture>
          </Link>

          <NavbarToggler onClick={() => setIsOpen(!isOpen)} style={{ zIndex: 1000 }} />

          <Collapse isOpen={isOpen} navbar>
            <Nav navbar className={'ml-auto'}>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  {authUser?.email ? authUser.email.split('@')[0] : 'menu'}
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem disabled className="text-nowrap">
                    {authUser?.email || 'Not logged in'}
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem text className="text-nowrap">
                    <div onClick={setProductionUnitsMCFE} style={{ cursor: 'pointer' }}>
                      Production Units as Mcfe{units === MCFE && ' ✓'}
                    </div>
                  </DropdownItem>
                  <DropdownItem text className="text-nowrap">
                    <div onClick={setProductionUnitsBOE} style={{ cursor: 'pointer' }}>
                      Production Units as BOE{units === BOE && ' ✓'}
                    </div>
                  </DropdownItem>
                  <DropdownItem divider />
                  <a href={`mailto:${UPSTREAM_EMAIL_ADDRESS}`} className="dropdown-item">
                    Contact Support
                  </a>
                  <DropdownItem divider />
                  {/*{authUser ? (*/}
                  {/*  <DropdownItemLink to={paths.LOGOUT}>Log out</DropdownItemLink>*/}
                  {/*) : (*/}
                  {/*  <DropdownItemLink to={paths.LOGIN}>Log in</DropdownItemLink>*/}
                  {/*)}*/}
                  {authUser ? (
                    <>
                      <DropdownItemLink to={paths.LOGOUT}>Log out</DropdownItemLink>
                      <DropdownItem divider />
                      <DropdownItem
                        onClick={() => setConfirmOpen(true)}
                        className="text-danger"
                      >
                        Delete my account
                      </DropdownItem>
                    </>
                  ) : (
                    <DropdownItemLink to={paths.LOGIN}>Log in</DropdownItemLink>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      {isLoggedIn && <MainMenu authUser={authUser} />}

      <ConfirmDialog
        isOpen={confirmOpen}
        toggle={() => !deleting && setConfirmOpen(false)}
        onConfirm={onDeleteConfirm}
        header="Delete account"
        body={
          <div>
            This will permanently delete your account and revoke access. This action cannot be undone.
            Are you sure you want to continue?
          </div>
        }
        confirmButtonText={deleting ? 'Deleting…' : 'Delete'}
        confirmButtonColor="danger"
        cancelButtonText="Cancel"
        cancelButtonColor="light"
      />
    </div>
  );
};

export default Header;
